<template>
    <div>
        <!-- Banner -->
        <banner-generic :data="data.hero"></banner-generic>

        <!-- Form & Details -->
        <section class="">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-8">
                        <div>
                            <div v-if="showSuccessMessage">
                                <div v-html="data.page.successMessage"></div>
                            </div>
                            <div v-else>
                                <div v-html="data.page.topContent"></div>
                                <div class="form-block">
                                    <contact-form-salesforce v-if="data.useSalesforceForm" :data="data.salesforceSettings" />
                                    <contact-form v-else :form="data.form" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-4">
                        <div class="contact-content" v-animate="'slide-up'">
                            <!-- Include text widget here -->
                            <h4 class="medium">{{data.page.right.title}}</h4>
                            <hr>
                            <div v-html="data.page.right.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div
            v-for="(element, index) in data.elements"
            :key="index"
        >
            <component :is="element.vueName" :data="element"/>
        </div>
    </div>
</template>

<script>
    import { BannerGeneric, ContactForm, ContactFormSalesforce, Cta } from "../components";

    // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";

    export default {
        name: "v-contact",
        components: {
            BannerGeneric,
            ContactForm,
            ContactFormSalesforce,
            Cta,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        },
        methods: {

        },
        data () {
            return {
                showSuccessMessage:false
            }
        },
        created() {

            if (window.location.href.indexOf("?submitted=1") > 1) {
                this.showSuccessMessage = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    .form-block {
        max-width: 700px;
    }

    .contact-content {
        background-color: #afccd7;
        padding: 3rem;
        top: 0px;
        position: relative;

        @media #{$md} {
         top: -200px;
        }

        hr{
            max-width: 285px;

        }

    }
</style>

<style lang="scss">
    @import "../../scss/abstracts/variables";
    
    body.ContactPage {
        .quicklinks {
            .container {
                border-top: solid 1px $brand-black;
            }
        }
    }
</style>
